export const areStatsEmpty: <TStats extends { value: number }>(stats: readonly TStats[]) => boolean = (stats) =>
    stats.every(({ value }) => value === 0);
